import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import TokenService from "../../service/TokenService";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import dayjs from "dayjs";

import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
function AccountPendingEntry() {
  const navigate = useNavigate();
  const { state } = useLocation();

  let poNumberFromList = state.expponumber;
  let billNumberFromList = state.expbillnumber;
  
  const [returnData, setreturnData] = useState([]);
  const today = dayjs();
  const [crnNumber, setcrnNumber] = useState();
  const [crnDate, setcrnDate] = useState(null);
  //const [error, setError] = useState("");
  const [accountEntryDate, setaccountEntryDate] = useState(null);
  const handleClose = () => {
    navigate("../accountpendiglist", { replace: true });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  // const [CRNGdateerror, setCRNdateerror] = useState("");
  // const [SentToAccountdateerror, setSentToAccountdateerror] = useState("");

  const [errors, setErrors] = useState({});

  const InsertPOData = async (e) => {
    e.preventDefault();

    let formErrors = {};

   // if (CRNGdateerror) formErrors.crnDateerror = "Invalid CRN Date";
    //if (SentToAccountdateerror)
    //  formErrors.sentdateerror = "Invalid Bill Sent Date";

    if (!crnDate) {formErrors.crnDateerror = "Invalid CRN Date";} 
    if (!accountEntryDate) {formErrors.sentdateerror = "Invalid Sent to Account Date";} 





    if (!crnNumber || crnNumber.length === 0)
      formErrors.errCRN = "Invalid CRN Number";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const crndt = new Date(crnDate);
      const CRNDAT =
        crndt.getFullYear() +
        "/" +
        parseInt(crndt.getMonth() + 1) +
        "/" +
        crndt.getDate();

      const billsentdt = new Date(accountEntryDate);
      const SENTDAT =
        billsentdt.getFullYear() +
        "/" +
        parseInt(billsentdt.getMonth() + 1) +
        "/" +
        billsentdt.getDate();

      apiClient.post("/AccountEntry", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList,
          vcrnnumber: crnNumber,
          vcrndate: CRNDAT,
          vbillsenttoaccountdate: SENTDAT,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
         // setError(response.data);
          navigate("../accountpendiglist", { replace: true });
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate CRN Not Allowed");
       }
     });
    }
  };

  const getdata = async (e) => {
    apiClient.post("/podetailscrn", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setreturnData(response.data[0]);
        //console.log(response.data[0]);
      })
      .catch(function (error) {
       // setError(error);
       alert(error);
      });
  };

  useEffect(() => {
    getdata();
  },[]);

  const headers = [
    ["Indent Number", "PO Number", "Consignee"],
    ["Item Name", "Bill Date", "Paymenttype"],
    ["Bill Number", "Billed Item Qty", "Billed Value"],
    ["Bill Passing Date", "Bill Type", ""],
  ];

  //
  const rows = [
    [returnData.IndentNumber, returnData.ponumber, returnData.POConsignee],
    [returnData.POItemName, returnData.billdate, returnData.paymentDesription],
    [returnData.billnumber, returnData.billitemQty, returnData.billitemValue],
    [returnData.billpassingdate, returnData.gemtype===1?'Gem Bill':'IREPS Bill', ""],
  ];


  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };
 



  return (
    <div >
      {/* <SriyanshCardHeader Title="Account Bill Received Date" /> */}
      
      <Card className="Formcard">
        {/* {error && (
          <ToasterAlerts
            type="info"
            title="Messasge"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )} */}
<div className="input-groupHeading">
     CRN Entry

            </div>
        <CardContent>
        <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">PO Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
        
            <ListHeaderTableComponent headers={headers} rows={rows} />
        
        </AccordionDetails>
      </Accordion>
     

          <div className="row">
            <div className="container mt-4">
              <div className="input-group">
                <CustomTextField
                  label="CRN Number"
                  value={crnNumber??''}
                  onChange={(e) => {
                    setcrnNumber(e.target.value);
                  }}
                  placeholder="CRN Number"
                  maxLength={50} // Set the maximum length
                  error={!!errors.errCRN}
                  helperText={errors.errCRN}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Date of CRN"
                  id="crndate"
                  value={crnDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setcrnDate)
                  } 

                  error={errors.crnDateerror}
                  // onError={(newError) =>
                  //   setCRNdateerror({ ...errors, crnDateerror: newError })
                  // }
                  maxDate={today}
                  // minDate={
                  //   returnData.billpassingdate ? dayjs(returnData.billpassingdate) : dayjs()
                  // }

                  minDate={
  returnData.gemtype === 0
    ? (returnData.billpassingdate ? dayjs(returnData.billpassingdate) : dayjs())
    : (returnData.billdate ? dayjs(returnData.billdate) : dayjs())
}

                />
              </div>

              <div className="input-group">
                <DatePickerComponent
                  label="Hardcopy of Bill Sent to Account Date"
                  id="accountyReceiptDate"
                  value={accountEntryDate}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setaccountEntryDate)
                  } 
                  error={errors.sentdateerror}
                  
                  maxDate={today}
                  minDate={
                    returnData.billpassingdate ? dayjs(returnData.billpassingdate) : dayjs()
                  }
                />
              </div>
            </div>
          </div>

          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
              >
                Save Data
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
        </CardContent>
      </Card>
    </div>
  );
}

export default AccountPendingEntry;
